// ./src/utils/localEndpoint.ts
//
// Which API address a per-brand LOCAL dashboard calls (`appEnv`, config/branding.ts). Pure — `check-local-brands` runs it.

/**
 * LOCAL ONLY (2026-10-28): on a per-brand local dashboard, `app.<brand>.localhost`, an API address configured as
 * `localhost` follows the page to `api.<brand>.localhost`. The session is a cookie set by the API, and the browser keeps
 * it only when the API is the SAME SITE as the page — `localhost` and `<brand>.localhost` are two sites, so it signed in
 * and landed straight back on sign-in. Plain localhost and every real address are left as configured. Pure.
 */
export const sameSiteLocalEndpoint = (url: string, pageHost: string): string => {
  const brandHost = /^app\.(.+\.localhost)$/.exec(String(pageHost ?? '').toLowerCase())?.[1];

  if (!brandHost || !url) {
    return url;
  }

  try {
    const u = new URL(url);

    if (u.hostname !== 'localhost') {
      return url;
    }

    u.hostname = `api.${brandHost}`;

    // `new URL('http://localhost:4000')` prints a trailing slash the address did not have.
    return u.pathname === '/' && !/\/$/.test(url) ? u.origin : u.toString();
  } catch {
    return url;
  }
};
